<template>
    <main class="app-main">
        <div class="video__bear error404__bear" id="bear"></div>
        <section class="error404">
            <h1 class="error404__title">
                <span class="error404__color">4</span>
                <span class="error404__color2">0</span>
                <span class="error404__color3">4</span>
            </h1>
            <h3 class="error404__message">Мечето не е намерено...</h3>
        </section>
    </main>
</template>

<script>
export default {
    name: 'Error404',
    data () {
        return {
            test: null
        }
    }
}
</script> 




// WEBPACK FOOTER //
// src/components/Error404.vue?d85619a8